const LABEL_ROUTE_NAME = 'token'

/**
 * Sends label page visits without a fresh tap (`?sd=`) or an existing report (`/:token` or `?token=`) to the error page.
 * Also keeps users from navigating back to the raw tap URL after it has been cleaned up.
 */
export default defineNuxtRouteMiddleware((to, from) => {
    const senseData = to.query.sd
    const token = (to.params.token as string | undefined) || (to.query.token as string | undefined)

    const isNavigatingFromLabelPage = from.name === LABEL_ROUTE_NAME
    const isNavigatingToLabelPage = to.name === LABEL_ROUTE_NAME

    if (isNavigatingFromLabelPage && isNavigatingToLabelPage && to.query.sd && !from.query.sd) return abortNavigation()

    if (!isNavigatingToLabelPage) return

    if (isNavigatingFromLabelPage && from.query.sd) return

    if (!senseData && !token) return navigateTo('/error')
})
